if (!customElements.get('sergilac-pack')) {
customElements.define('sergilac-pack', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.form = this.closest('form');
    // Quando existirem variantes por cor com componentes, enviar o ID da cor escolhida.
    // Com um só produto genérico, manter o comportamento anterior.
    try {
      this.variantByColor = JSON.parse(this.querySelector('[data-pack-variants]')?.textContent || '{}');
    } catch {
      this.variantByColor = {};
    }
    this.variantInputs = this.form?.querySelectorAll('input[name="id"]');
    this.property = this.querySelector('[data-pack-color-value]');
    this.summary = this.querySelector('[data-pack-total]');
    const row = this.querySelector('[data-pack-row]');
    const label = document.createElement('label');
    label.textContent = this.dataset.kind === 'ral' ? 'Código RAL' : 'Cor';
    this.color = document.createElement(this.dataset.kind === 'ral' ? 'input' : 'select');
    this.color.dataset.packColor = '';
    this.color.setAttribute('aria-label', this.dataset.kind === 'ral' ? 'Código RAL' : 'Cor');
    this.color.required = true;
    if (this.dataset.kind === 'ral') {
      this.color.placeholder = 'Ex.: RAL 9005';
      this.color.pattern = '(?:[Rr][Aa][Ll] ?)?[0-9]{4}';
      this.color.maxLength = 8;
    } else {
      this.color.add(new Option('Escolha a cor',''));
      this.dataset.colors.split('|').forEach(value => this.color.add(new Option(value,value)));
    }
    label.append(this.color);
    row.append(label);
    if (this.dataset.kind === 'ral') {
      const finishLabel = document.createElement('label');
      finishLabel.textContent = 'Acabamento';
      this.finish = document.createElement('select');
      this.finish.setAttribute('aria-label','Acabamento');
      ['Brilhante','Mate','Texturizado'].forEach(value => this.finish.add(new Option(value,value)));
      finishLabel.append(this.finish);
      row.append(finishLabel);
    }
    const kgLabel = document.createElement('label');
    kgLabel.textContent = 'Quantidade em kg';
    const stepper = document.createElement('div');
    stepper.className = 'pack-stepper';
    const minus = document.createElement('button');
    minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label','Diminuir kg');
    this.kg = document.createElement('input');
    this.kg.type = 'number'; this.kg.min = '1'; this.kg.max = '30'; this.kg.step = '1'; this.kg.value = '1';
    this.kg.required = true; this.kg.setAttribute('aria-label','Quantidade em kg');
    const plus = document.createElement('button');
    plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label','Aumentar kg');
    minus.addEventListener('click',()=>{this.kg.value=String(Math.max(1,Number(this.kg.value || 1)-1));this.sync();});
    plus.addEventListener('click',()=>{this.kg.value=String(Math.min(30,Number(this.kg.value || 1)+1));this.sync();});
    this.minus = minus; this.plus = plus;
    stepper.append(minus,this.kg,plus);
    kgLabel.append(stepper);
    row.append(kgLabel);
    this.addEventListener('input',()=>this.sync());
    this.addEventListener('change',()=>this.sync());
    this.form.addEventListener('submit',event=>{
      this.sync();
      if (!this.color.checkValidity() || !this.kg.checkValidity()) {
        event.preventDefault(); event.stopImmediatePropagation(); this.form.reportValidity();
      }
    },true);
    this.form.addEventListener('formdata',event=>{
      this.sync();
      event.formData.set('quantity',String(this.total || 1));
      event.formData.set('properties[Cor escolhida]',this.property.value);
    });
    this.observer = new MutationObserver(()=>this.syncLegacy());
    this.observer.observe(this.closest('main') || this.form.parentElement,{childList:true,subtree:true});
    this.sync();
  }
  disconnectedCallback() {this.observer?.disconnect();}
  syncLegacy() {
    for (const field of (this.closest('main') || document).querySelectorAll('.po-textAreaField-textarea')) {
      if (field.value !== this.property.value) {
        Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype,'value').set.call(field,this.property.value);
        field.dispatchEvent(new Event('input',{bubbles:true}));
        field.dispatchEvent(new Event('change',{bubbles:true}));
      }
      const wrapper=field.closest('.po-textArea-root');
      if(wrapper)wrapper.style.display='none';
    }
  }
  sync() {
    this.total=Number(this.kg.value);
    let color=this.color.value.trim();
    if(this.dataset.kind==='ral' && color) color='RAL '+color.replace(/ral\s*/i,'')+' '+this.finish.value;
    this.property.value=color;
    if (this.dataset.kind !== 'ral' && Object.keys(this.variantByColor).length > 1) {
      const selectedId = this.variantByColor[this.color.value];
      if (selectedId) {
        for (const field of this.variantInputs || []) field.value = String(selectedId);
      }
    }
    const input=this.form.querySelector('input[name="quantity"]');
    if(input)input.value=String(this.total || 1);
    this.minus.disabled=this.total<=1;
    this.plus.disabled=this.total>=30;
    const money=new Intl.NumberFormat('pt-PT',{style:'currency',currency:this.dataset.currency || 'EUR'});
    this.summary.textContent='Total: '+(this.total || 0)+' kg — '+money.format((this.total || 0)*Number(this.dataset.price)/100)+' + portes';
    this.syncLegacy();
  }
});
}